import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PaymentNotification } from '../../../accounts-notifications/models/accounts-notifications.model';

@Component({
  selector: 'app-payment-notification',
  imports: [CommonModule, RouterModule],
  templateUrl: './payment-notification.component.html',
  styleUrls: ['./payment-notification.component.scss'],
})
export class PaymentNotificationComponent {
  @Input() set notification(notification: PaymentNotification) {
    this.isAutoPayment =
      notification.autoPayType === 'RECURRINGPAYMENT' || notification.autoPayType === 'RECURRINGMATCHSCHEDULE';
    this.amount = notification.amount;
    this.scheduledDate = notification.scheduledDate;
  }
  @Input() baseHrefUrl?: string;
  isAutoPayment: boolean;
  amount: number;
  scheduledDate: string;
  @Input() accountId: number;
}
